(ns frontend.ui.page.lp-report-editor.step-3-review.event
  (:require
   [re-frame.core :as rf]
   [frontend.controller.websocket.event :as ws]
   [frontend.ui.page.lp-report-editor.event :as editor-event]))

(rf/reg-event-fx
 ::submitted-for-approval-ok
 (fn [{db :db} [_ investor-identifier resp]]
   {:db (-> db
            (assoc-in [:lp-report-editor :lp-report :lp-report/step]
                      :lp-report.step/pending-approval))
    :fx [[:dispatch [::editor-event/activate-step :lp-report.step/pending-approval]]]}))

(rf/reg-event-fx
 ::submit-for-approval-failed
 (fn [{db :db} [_ err]]
   (js/console.log "Review failed : " err)))

(rf/reg-event-fx
 ::submit-cycle-for-approval
 (fn [{db :db} [_ report-id]]
   {::ws/send {:id         :lp-report/submit-cycle-for-approval
               :body       {:report-id report-id}
               :on-success [::submitted-for-approval-ok report-id]
               :on-error   [::submit-for-approval-failed report-id]}}))
